// extracted by mini-css-extract-plugin
export default {"container":"banner-planos_container__UeQXu","lista-planos":"banner-planos_lista-planos__TL1b8"};